import React from "react";
import MTabs from "@mui/material/Tabs";

const Tabs = ({ children, ...props }) => {
  return <MTabs {...props}>{children}</MTabs>;
};

export default React.memo(Tabs);
